import React, { Component } from 'react';
import { Form, Container, Row, Col, Label, Input, Button, Alert, FormGroup, Table, Badge, Tooltip, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

export default class AddEditBoard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: false,
            boardTypes: [],
            compensationTerms: [],
            board: { name: '', type: '', totalSeats: 0, termLength: 0, compensation: 0.0, councilConfirmation: false, backgroundCheck: false, isActive: true, description: '', comments: '', compensationTerm: '' },
            applications: [],
            currentMembers: [],
            tooltipBoardIdOpen: false,
            tooltipMeetingTypeIdOpen: false,
            addEmployeeModalOpen: false,
            employee: { boardId: this.props.match.params.id}
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        document.title = this.getTitle(id > 0 ? true : false, id);

        if (id > 0) {       

            fetch('/api/boards/' + id, {
                method: 'GET'
            })
            .then(resp => resp.json())
            .then(data => {
                this.setState({ board: data, editMode: true });
            })

            fetch('/api/boardmembers/getboardmembersbyboardid/' + id, {
                method: 'GET'
            })
            .then(resp => resp.json())
            .then(data => this.setState({ currentMembers: data }))

            fetch('/api/applications/getapplicationsbyboard/' + id, {
                method: 'GET'
            })
            .then(resp => resp.json())
            .then(data => this.setState({ applications: data }))
        }

        fetch('/api/codes/type/boardtype', {
            method: 'GET'
        })
        .then(response => response.json())
        .then(data => {
            this.setState({ boardTypes: data });
        })  

        fetch('/api/codes/type/compensationTerm', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ compensationTerms: data });
        })   
    }

    saveChanges = () => {
        const { id } = this.props.match.params;

        fetch('/api/boards/' + id, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.board)
        })
        .then(response => {
            if (response.ok) {
                this.setState({ showSuccess: true })
            } else {
                response.json().then(data => { this.setState({ showError: true, errorMessage: data }) });
            }
        })
    }

    postNew = () => {
        fetch('/api/boards', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.board)
        })
            .then(response => {
                if (response.ok) {
                    this.props.history.push('/admin/boards');
                } else {
                    response.json().then(data => {
                        this.setState({showError: true, errorMessage: data })
                    });
                }
            })
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.editMode) {
            this.saveChanges();
        } else {
            this.postNew();
        }
    }

    handleChange = (e) => {
        this.setState({ board: { ...this.state.board, [e.target.name]: e.target.value } });
    }

    onCheckedChange = (e) => {
        this.setState({ board: { ...this.state.board, [e.target.name]: e.target.checked } });
    }

    getTitle = (isEditMode, id) => {
        return isEditMode ? "Edit Board " + id : "Create New Board";
    }

    toggleBoardIdTooltip = () => {
        this.setState({ tooltipBoardIdOpen: !this.state.tooltipBoardIdOpen })
    }

    toggleMeetingTypeIdTooltip = () => {
        this.setState({ tooltipMeetingTypeIdOpen: !this.state.tooltipMeetingTypeIdOpen })
    }

    onBoardMemberClick = (id) => {
        this.props.history.push('/admin/boardmember/' + id);
    }

    onApplicationClick = (id) => {
        this.props.history.push('/admin/application/' + id);
    }

    toggleAddEmployeeModal = () => {
        this.setState({ addEmployeeModalOpen: !this.state.addEmployeeModalOpen })
    }

    handleEmployeeChange = (e) => {
        let { employee } = this.state;
        employee[e.target.name] = e.target.value;
        this.setState({ employee: employee });
    }

    addEmployee = (e) => {
        e.preventDefault();
        fetch('/api/boardmembers/addemployee', {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'content-type':'application/json'
            },
            body: JSON.stringify(this.state.employee)
        })
        .then(resp => {
            if(resp.ok) {
                resp.json().then(data => {
                    this.toggleAddEmployeeModal();
                    let { currentMembers } = this.state;
                    currentMembers.push({ firstName: data.firstName, lastName: data.lastName, position: data.position, title: data.title, expirationDate: data.expirationDate })
                    this.setState({ currentMembers: currentMembers });
                })
            }
        })
    }

    render() {
        const { id, name, type, totalSeats, compensation, termLength, councilConfirmation, backgroundCheck, isActive, description, comments, icompassBoardId, icompassMeetingTypeId, compensationTerm } = this.state.board;
        const { editMode, boardTypes, showSuccess, showError, errorMessage, applications, currentMembers, tooltipBoardIdOpen, tooltipMeetingTypeIdOpen, compensationTerms, addEmployeeModalOpen } = this.state;

        let vacancies = [];

        if(editMode) {
            for (let i = 0; i < totalSeats - currentMembers.length; i++) {
                vacancies.push(
                    <tr key={i}>
                        <td colSpan='4'>Vacant Seat</td>
                    </tr>
                )
            }
        }
 
        return (
            <div>
                {showSuccess &&
                    <Alert color='success' isOpen={showSuccess} toggle={this.toggleAlert}>
                        Your changes have been saved.
                    </Alert>
                }
                {showError &&
                    <Alert color='danger' isOpen={showError} toggle={this.toggleAlert}>
                        <p>An error occured saving your changes.  Nothing has been saved to the database.</p>
                        <p>{errorMessage}</p>
                    </Alert>
                }
                <Modal isOpen={addEmployeeModalOpen} toggle={this.toggleAddEmployeeModal} size='lg'>
                    <ModalHeader toggle={this.toggleAddEmployeeModal}>Add Employee to Board</ModalHeader>
                    <ModalBody>
                        <p className="lead">Fill out the form below to add an employee to this board.  This operation will create a non-accessible and non-editable profile for the employee and place that employee on the board.</p>
                        <Form onSubmit={this.addEmployee}>
                            <Row>
                                <Col sm='4'>
                                    <FormGroup>
                                        <Label for="firstName">First Name</Label>
                                        <Input name='firstName' maxLength={50} onChange={this.handleEmployeeChange} required />
                                    </FormGroup>
                                </Col>
                                <Col sm='4'>
                                    <FormGroup>
                                        <Label for="lastName">Last Name</Label>
                                        <Input name='lastName' maxLength={50} onChange={this.handleEmployeeChange} required />
                                    </FormGroup>
                                </Col>
                                <Col sm='4'>
                                    <FormGroup>
                                        <Label for='email'>Email Address</Label>
                                        <Input name='email' maxLength={50} onChange={this.handleEmployeeChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm='4'>
                                    <FormGroup>
                                        <Label for='position'>Position</Label>
                                        <Input name='position' maxLength={100} onChange={this.handleEmployeeChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm='4'>
                                    <FormGroup>
                                        <Label for='title'>Title</Label>
                                        <Input name='title' maxLength={100}  onChange={this.handleEmployeeChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm='4'>
                                    <FormGroup>
                                        <Label for='expirationDate'>Expiration Date</Label>
                                        <Input name='expirationDate' type='date' onChange={this.handleEmployeeChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Button type='submit'>Add Employee</Button>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        
                    </ModalFooter>
                </Modal>
                <h4>{this.getTitle(editMode, id)}</h4>
                <Form className='form-border' onSubmit={this.handleSubmit}>
                    <Container>
                        <Row>
                            <Col sm='12'>
                                <FormGroup>
                                    <Label for='name'>Board Name</Label>
                                    <Input name='name' maxLength={120} id='name' required onChange={this.handleChange} value={name} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label>Type</Label>
                                    <Input type="select" name="type" required onChange={this.handleChange} value={type || ''}>
                                        <option value=''></option>
                                        {boardTypes && boardTypes.length > 0 && boardTypes
                                            .filter(item => item.isActive === true || item.id === type)
                                            .map((item) => {
                                                return (
                                                    <option key={item.id} value={item.id}>{item.description}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for='totalSeats'>Total Seats</Label>
                                    <Input name='totalSeats' required min='1' step='1' pattern='^\d{1,2}$' value={totalSeats || ''} onChange={this.handleChange} />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for='termLength'>Term Length</Label>
                                    <Input name='termLength' min='0' step='1' pattern='^\d{0,1}$' value={termLength || ''} onChange={this.handleChange} />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for='compensation'>Compensation</Label>
                                    <Input name='compensation' value={compensation || ''} onChange={this.handleChange} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='3' className="my-auto">
                                <FormGroup>
                                    <Label>Compensation Term</Label>
                                    <Input type="select" name="compensationTerm" onChange={this.handleChange} value={compensationTerm || ''}>
                                        <option value=''></option>
                                        {compensationTerms && compensationTerms.length > 0 && compensationTerms
                                            .filter(item => item.isActive === true || item.id === type)
                                            .map((item) => {
                                                return (
                                                    <option key={item.id} value={item.id}>{item.description}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm='3' className="my-auto">
                                <FormGroup check>
                                    <Label for='councilConfirmation'>
                                        <Input name='councilConfirmation' type='checkbox' checked={councilConfirmation} onChange={this.onCheckedChange} />
                                        Requires Council Confirmation
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col sm='3' className="my-auto">
                                <FormGroup check>
                                    <Label for='backgroundCheck'>
                                        <Input name='backgroundCheck' type='checkbox' checked={backgroundCheck} onChange={this.onCheckedChange} />
                                        Requires Background Check
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col sm='3' className="my-auto">
                                <FormGroup check>
                                    <Label for='isActive'>
                                        <Input name='isActive' type='checkbox' checked={isActive} onChange={this.onCheckedChange} />
                                        Active
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='6'>
                                <FormGroup>
                                    <Label for='IcompassBoardId'>ICompass Board Id</Label> <Badge className='ml-1' id='ICompassBoardIdTooltip'>?</Badge>
                                    <Tooltip placement='right' isOpen={tooltipBoardIdOpen} target="ICompassBoardIdTooltip" toggle={this.toggleBoardIdTooltip}>Enter the Id number associated with the board in ICompass.  If left blank, no meeting information will be provided to site visitors.<div>ex. 159302446</div></Tooltip>
                                    <Input name='icompassBoardId' onChange={this.handleChange} value={icompassBoardId || ''} />
                                </FormGroup>
                            </Col>
                            <Col sm='6'>
                                <FormGroup>
                                    <Label for='IcompassMeetingTypeId'>ICompass Meeting Type Id</Label> <Badge className='ml-1' id='ICompassMeetingTypeIdTooltip'>?</Badge>
                                    <Tooltip placement='right' isOpen={tooltipMeetingTypeIdOpen} target="ICompassMeetingTypeIdTooltip" toggle={this.toggleMeetingTypeIdTooltip}>Enter the Meeting Type Id number associated with the board in ICompass.  If left blank, no meeting information will be provided to site visitors.<div>ex. 10</div></Tooltip>
                                    <Input name='icompassMeetingTypeId' onChange={this.handleChange} value={icompassMeetingTypeId || ''} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='12'>
                                <FormGroup>
                                    <Label for='description'>Description</Label>
                                    <Input name='description' type='textarea' maxLength={8000} rows="10" onChange={this.handleChange} value={description ? description : ''} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='12'>
                                <FormGroup>
                                    <Label for='comments'>Comments</Label>
                                    <Input name='comments' type='textarea' maxLength={4000} rows="3" onChange={this.handleChange} value={comments ? comments : ''} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <br />                       
                    </Container>
                    <br />
                    <Button type='submit'>{editMode ? 'Save' : 'Create'}</Button>
                </Form>
                {this.state.editMode &&
                    <div className='mt-3 form-border'>
                        <h4>Member Management</h4>
                        <hr />
                        <h5>Current Members</h5>
                        <Table striped hover>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Title</th>
                                    <th>Position</th>
                                    <th>Expiration Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentMembers.map(item => {
                                    return(
                                        <tr style={{cursor: "pointer"}} key={item.id} onClick={() => this.onBoardMemberClick(item.id)}>
                                            <td>{item.firstName + ' ' +  item.lastName}</td>
                                            <td>{item.title}</td>
                                            <td>{item.position}</td>
                                            <td>{(item.expirationDate ? new Date(item.expirationDate).toLocaleDateString("en-US") : "")}</td>
                                        </tr>
                                    )
                                })}

                                {vacancies}

                            </tbody>
                        </Table>
                        {vacancies.length > 0 &&
                            <Button onClick={this.toggleAddEmployeeModal}>Add Employee to Board</Button>
                        }
                        <hr />
                        <h5>Current Applications</h5>
                        <Table striped hover>
                            <thead>
                                <tr>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Application Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {applications.length === 0 &&
                                    <tr><td colSpan='3'>There are no active applications for this board.</td></tr>
                                }
                                {applications.map(item => {
                                    return(
                                        <tr style={{cursor: "pointer"}} key={item.id} onClick={() => this.onApplicationClick(item.id)}>
                                            <td>{item.firstName}</td>
                                            <td>{item.lastName}</td>
                                            <td>{item.status}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </div>
                }
            </div>
        )
    }
}